import timelineConfig from './reducers/timeline_config';
import timelineData from './reducers/timeline_data';
import dateRange from './reducers/date_range';
import relatedRecordsOpen from './reducers/related_records_open';
import Immutable from 'immutable';

export const reducers = {
  timelineConfig,
  timelineData,
  dateRange,
  relatedRecordsOpen,
};

export const initialState = Immutable.Map({
  timelineConfig: Immutable.Map(),
  timelineData: Immutable.Map(),
  dateRange: Immutable.Map(),
  relatedRecordsOpen: false,
});
